/**
 * Tools
 */

class Tools {

	static getScrollTop() {
		return (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
	}

	static scrollTo ( x, y ) {
		window.scrollTo(x,y);
	}

	static arrayify( nodeCollection ) {

		return Array.from( nodeCollection );

	}

	static getGlobalHeight () {

		const body = document.body;
		const html = document.documentElement;

		return Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
	}

	static getParams() {

		let query_string = {};
		let query = window.location.search.substring(1);
		let vars = query.split("&");

		for (let i=0;i<vars.length;i++) {
		  var pair = vars[i].split("=");

		  if (typeof query_string[pair[0]] === "undefined") {
		      query_string[pair[0]] = pair[1];

		  } else if (typeof query_string[pair[0]] === "string") {
		      var arr = [ query_string[pair[0]], pair[1] ];
		      query_string[pair[0]] = arr;

		  } else {
		      query_string[pair[0]].push(pair[1]);
		  }
		}

		return query_string;
	}

	static getInnerHeight ( element ) {
		
		const styles = window.getComputedStyle(element);

		return element.clientHeight - parseFloat(styles.paddingTop) + parseFloat(styles.paddingBottom);

	}
	
}

export default Tools;
